import React, { SFC, useState } from 'react'
import { DeleteOverlay } from './deleteOverlay'
import { ImageGallery } from './imageGallery'
import { AddImage } from './addImage'
import { ImageList, makeStyles, Theme, ImageListItem, createStyles } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { Image } from '../types/common'
import { Image as ImageComponent } from '../components/Image'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        imageList: {
            flexWrap: 'nowrap',
            transform: 'translateZ(0)',
        },
    })
)

interface ImagesManagerProps {
    images: Image[]
    imageClassName?: string
    imageCols?: number
    uploadAction?(files: File[]): Promise<any>
    uploadError?(): void
    uploadProgressStateSelector?(state: any): any
    deleteAction?(image: Image): Promise<any>
    deleteProgressStateSelector?(state: any): any
}

const ImagesManager: SFC<ImagesManagerProps> = ({
    images,
    imageClassName,
    imageCols,
    uploadAction,
    uploadError,
    uploadProgressStateSelector,
    deleteAction,
    deleteProgressStateSelector,
}) => {
    const [selectedImage, setSelectedImage] = useState<number>()
    const classes = useStyles()

    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

    const imageColsToUse = imageCols ?? (isDesktop ? 1.5 : 3)

    return (
        <div>
            {selectedImage !== undefined && (
                <ImageGallery
                    urls={images.map((x) => x.url)}
                    initialIndex={selectedImage}
                    onClose={() => setSelectedImage(undefined)}
                />
            )}
            <ImageList className={classes.imageList} cols={13} rowHeight={'auto'}>
                {images.map((x: any, index: number) => (
                    <ImageListItem key={x.id} cols={imageColsToUse}>
                        {deleteAction && deleteProgressStateSelector ? (
                            <DeleteOverlay
                                deleteAction={async () => await deleteAction(x)}
                                progressStateSelector={deleteProgressStateSelector}
                            >
                                <ImageComponent
                                    url={x.url}
                                    className={imageClassName}
                                    imageClassName={imageClassName}
                                    onClick={() => setSelectedImage(index)}
                                />
                            </DeleteOverlay>
                        ) : (
                            <ImageComponent
                                url={x.url}
                                className={imageClassName}
                                imageClassName={imageClassName}
                                onClick={() => setSelectedImage(index)}
                            />
                        )}
                    </ImageListItem>
                ))}
                {uploadProgressStateSelector && uploadAction && (
                    <ImageListItem cols={imageColsToUse}>
                        <AddImage
                            className={imageClassName}
                            progressStateSelector={uploadProgressStateSelector}
                            onUpload={uploadAction}
                            onUploadError={uploadError}
                        />
                    </ImageListItem>
                )}
            </ImageList>
        </div>
    )
}

export default ImagesManager
